/* eslint-disable */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
//const query = new URLSearchParams(window.location.search);
//const token = query.get('inv')
//var invCode = localStorage.getItem("inv");
// devConsoleLog("Invitation Code in AuthConfig File", token);
/**
 *
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

export const b2cPolicies = {
  names: {
    // signUpSignIn: "B2C_1_signupsignin",
    signUpSignIn: 'B2C_1_FreedomSignUp',
    // signUpSignIn: "B2C_1_FreedomSignUp",
    forgotPassword: 'B2C_1_passwordreset',
    editProfile: 'B2C_1_editprofile'
  },
  authorities: {
    signUpSignIn: {
      // authority: "https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/B2C_1_signupsignin",
      authority: 'https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/B2C_1_FreedomSignUp'
    },
    forgotPassword: {
      authority: 'https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/B2C_1_passwordreset'
    },
    editProfile: {
      authority: 'https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/B2C_1_editprofile'
    }
  },
  authorityDomain: 'myfreedomltd.b2clogin.com'
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    //clientId: "a2cac431-7051-4aaa-95af-1698e1bc9713",
    clientId: '2353052a-5c6b-4982-b0fd-e7275e4234c5',
    // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    // redirectUri: window.location.origin + "/Home",
    redirectUri: '/', //window.location.origin + "/",
    // redirectUri: localhost ? localhost : siteUrl,//window.location.origin + "/",
    validateAuthority: false,

    // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    // postLogoutRedirectUri: `https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_signupsignin&client_id=2353052a-5c6b-4982-b0fd-e7275e4234c5&nonce=defaultNonce&redirect_uri=${window.location.origin}&scope=openid&response_type=id_token&prompt=login`, // Indicates the page to navigate after logout.
    postLogoutRedirectUri: `https://myfreedomltd.b2clogin.com/myfreedomltd.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_FreedomSignUp&client_id=2353052a-5c6b-4982-b0fd-e7275e4234c5&nonce=defaultNonce&redirect_uri=${window.location.origin}&scope=openid&response_type=id_token&prompt=login`, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['https://myfreedomltd.onmicrosoft.com/2353052a-5c6b-4982-b0fd-e7275e4234c5/User.ReadAll', 'openid', 'offline_access']
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
// export const protectedResources = {
//     apiHello: {
//         endpoint: "https://algo-api.azure-api.net/api/v1/user/getuserbyemail('ZubairMunir263@gmail.com')",
//     scopes: ["https://myfreedomltd.onmicrosoft.com/2353052a-5c6b-4982-b0fd-e7275e4234c5/User.ReadAll"], // e.g. api://xxxxxx/access_as_user
//     },
// }
